// removed by extract-text-webpack-plugin
module.exports = {"container":"container___ZmbUM","header":"header___2P8AO","newRenderTitle":"newRenderTitle___2O54Z","divider":"divider___1Ptgm","description":"description___2I6MZ","dulplicateAsset":"dulplicateAsset___3QtgQ","paginationContainer":"paginationContainer___1iboN","paginator":"paginator___1WJ9m","renderSubTitle":"renderSubTitle___3VbXC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RenderList/RenderList.module.css
// module id = 403
// module chunks = 0